module.exports = __webpack_public_path__ + "static/media/cheesecake.6ae17dc8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/cheesecake.JPG
// module id = 568
// module chunks = 0